// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModernImageModelNode-container {
  --model-accent: #1463ff;
  --model-soft: #eaf1ff;
  position: relative;
  width: 356px;
  overflow: visible;
  border: 1px solid color-mix(in srgb, var(--model-accent) 38%, #d9dde6);
  border-radius: 18px;
  background: #fcfcfa;
  box-shadow: 0 16px 44px rgba(31, 42, 68, 0.12), 0 2px 8px rgba(31, 42, 68, 0.06);
  color: #18202c;
  font-family: Inter, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.ModernImageModelNode-container:hover {
  border-color: color-mix(in srgb, var(--model-accent) 64%, #ffffff);
  box-shadow: 0 20px 50px rgba(31, 42, 68, 0.16), 0 2px 8px rgba(31, 42, 68, 0.07);
}

.ModernImageModelNode-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 76px;
  padding: 14px 18px;
  border-bottom: 1px solid color-mix(in srgb, var(--model-accent) 14%, #e6e9ef);
  border-radius: 17px 17px 0 0;
  background: linear-gradient(115deg, var(--model-soft), #fcfcfa 70%);
}

.ModernImageModelNode-brand {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.ModernImageModelNode-icon {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  place-items: center;
  border-radius: 11px;
  background: var(--model-accent);
  box-shadow: 0 7px 16px color-mix(in srgb, var(--model-accent) 22%, transparent);
  color: #fff;
  font-size: 20px;
  line-height: 1;
}

.ModernImageModelNode-title {
  overflow: hidden;
  color: #111827;
  font-size: 16px;
  font-weight: 760;
  letter-spacing: -0.02em;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ModernImageModelNode-model-id {
  margin-top: 3px;
  color: #697386;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.ModernImageModelNode-mode {
  flex: 0 0 auto;
  padding: 5px 8px;
  border: 1px solid color-mix(in srgb, var(--model-accent) 24%, #e4e7ec);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.7);
  color: var(--model-accent);
  font-size: 11px;
  font-weight: 700;
}

.ModernImageModelNode-body {
  display: grid;
  gap: 12px;
  padding: 15px 18px 18px;
}

.ModernImageModelNode-connection-row {
  display: flex;
  gap: 8px;
}

.ModernImageModelNode-connection-row span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 7px;
  background: #f0f2f5;
  color: #7a8494;
  font-size: 11px;
  font-weight: 650;
}

.ModernImageModelNode-connection-row span.is-connected {
  background: var(--model-soft);
  color: var(--model-accent);
}

.ModernImageModelNode-field {
  display: grid;
  grid-template-columns: 76px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  margin: 0;
}

.ModernImageModelNode-field > span {
  color: #596273;
  font-size: 12px;
  font-weight: 650;
}

.ModernImageModelNode-field select {
  width: 100%;
  height: 34px;
  padding: 0 30px 0 10px;
  border: 1px solid #dde1e8;
  border-radius: 9px;
  outline: 0;
  background: #fff;
  color: #252d3a;
  font-size: 12px;
}

.ModernImageModelNode-field select:focus {
  border-color: var(--model-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--model-accent) 11%, transparent);
}

.ModernImageModelNode-segments {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  overflow: hidden;
  border: 1px solid #dde1e8;
  border-radius: 9px;
  background: #f4f5f7;
}

.ModernImageModelNode-segments button {
  min-width: 0;
  height: 32px;
  border: 0;
  border-right: 1px solid #e4e7ec;
  background: transparent;
  color: #687284;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

.ModernImageModelNode-segments button:last-child {
  border-right: 0;
}

.ModernImageModelNode-segments button.is-active {
  background: var(--model-accent);
  color: #fff;
}

.ModernImageModelNode-toggle {
  display: grid;
  grid-template-columns: 18px 1fr;
  column-gap: 8px;
  align-items: center;
  margin: 0;
  padding: 10px;
  border: 1px solid #e3e6eb;
  border-radius: 10px;
  background: #f7f8f9;
  cursor: pointer;
}

.ModernImageModelNode-toggle input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--model-accent);
}

.ModernImageModelNode-toggle span {
  color: #323b49;
  font-size: 12px;
  font-weight: 700;
}

.ModernImageModelNode-toggle small {
  grid-column: 2;
  margin-top: 2px;
  color: #7a8494;
  font-size: 10px;
}

.ModernImageModelNode-error {
  padding: 8px 10px;
  border: 1px solid #ffd0cd;
  border-radius: 9px;
  background: #fff3f2;
  color: #b42318;
  font-size: 11px;
  line-height: 1.4;
}

.ModernImageModelNode-generate {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 0;
  border-radius: 11px;
  background: var(--model-accent);
  box-shadow: 0 8px 18px color-mix(in srgb, var(--model-accent) 20%, transparent);
  color: #fff;
  font-size: 13px;
  font-weight: 760;
  cursor: pointer;
}

.ModernImageModelNode-generate:hover:not(:disabled) {
  filter: brightness(0.94);
  transform: translateY(-1px);
}

.ModernImageModelNode-generate:disabled,
.ModernImageModelNode-segments button:disabled,
.ModernImageModelNode-field select:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.ModernImageModelNode-spinner {
  width: 13px;
  height: 13px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ModernImageModelNode-spin 0.8s linear infinite;
}

.ModernImageModelNode-duplicate {
  position: absolute;
  z-index: 4;
  top: -12px;
  right: -12px;
  display: grid;
  width: 28px;
  height: 28px;
  place-items: center;
  border: 1px solid #e0e4ea;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 5px 14px rgba(31, 42, 68, 0.14);
  color: #515c6c;
  cursor: pointer;
}

.ModernImageModelNode-handle {
  width: 11px !important;
  height: 11px !important;
  border: 2px solid #fff !important;
  background: var(--model-accent) !important;
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--model-accent) 35%, #d5dae3);
}

.ModernImageModelNode-handle-label {
  position: absolute;
  top: 50%;
  right: 13px;
  width: max-content;
  padding: 3px 7px;
  transform: translateY(-50%);
  border: 1px solid #e0e4ea;
  border-radius: 7px;
  background: #fff;
  color: #596273;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

@keyframes ModernImageModelNode-spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/ModernImageModelNode.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,sEAAsE;EACtE,mBAAmB;EACnB,mBAAmB;EACnB,gFAAgF;EAChF,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,kEAAkE;EAClE,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6EAA6E;EAC7E,4BAA4B;EAC5B,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,+EAA+E;EAC/E,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sEAAsE;EACtE,oBAAoB;EACpB,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,+EAA+E;EAC/E,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;EAGE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,0CAA0C;EAC1C,0EAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".ModernImageModelNode-container {\n  --model-accent: #1463ff;\n  --model-soft: #eaf1ff;\n  position: relative;\n  width: 356px;\n  overflow: visible;\n  border: 1px solid color-mix(in srgb, var(--model-accent) 38%, #d9dde6);\n  border-radius: 18px;\n  background: #fcfcfa;\n  box-shadow: 0 16px 44px rgba(31, 42, 68, 0.12), 0 2px 8px rgba(31, 42, 68, 0.06);\n  color: #18202c;\n  font-family: Inter, \"PingFang SC\", \"Microsoft YaHei\", sans-serif;\n}\n\n.ModernImageModelNode-container:hover {\n  border-color: color-mix(in srgb, var(--model-accent) 64%, #ffffff);\n  box-shadow: 0 20px 50px rgba(31, 42, 68, 0.16), 0 2px 8px rgba(31, 42, 68, 0.07);\n}\n\n.ModernImageModelNode-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-height: 76px;\n  padding: 14px 18px;\n  border-bottom: 1px solid color-mix(in srgb, var(--model-accent) 14%, #e6e9ef);\n  border-radius: 17px 17px 0 0;\n  background: linear-gradient(115deg, var(--model-soft), #fcfcfa 70%);\n}\n\n.ModernImageModelNode-brand {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n\n.ModernImageModelNode-icon {\n  display: grid;\n  width: 38px;\n  height: 38px;\n  flex: 0 0 38px;\n  place-items: center;\n  border-radius: 11px;\n  background: var(--model-accent);\n  box-shadow: 0 7px 16px color-mix(in srgb, var(--model-accent) 22%, transparent);\n  color: #fff;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.ModernImageModelNode-title {\n  overflow: hidden;\n  color: #111827;\n  font-size: 16px;\n  font-weight: 760;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ModernImageModelNode-model-id {\n  margin-top: 3px;\n  color: #697386;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n}\n\n.ModernImageModelNode-mode {\n  flex: 0 0 auto;\n  padding: 5px 8px;\n  border: 1px solid color-mix(in srgb, var(--model-accent) 24%, #e4e7ec);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--model-accent);\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.ModernImageModelNode-body {\n  display: grid;\n  gap: 12px;\n  padding: 15px 18px 18px;\n}\n\n.ModernImageModelNode-connection-row {\n  display: flex;\n  gap: 8px;\n}\n\n.ModernImageModelNode-connection-row span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 8px;\n  border-radius: 7px;\n  background: #f0f2f5;\n  color: #7a8494;\n  font-size: 11px;\n  font-weight: 650;\n}\n\n.ModernImageModelNode-connection-row span.is-connected {\n  background: var(--model-soft);\n  color: var(--model-accent);\n}\n\n.ModernImageModelNode-field {\n  display: grid;\n  grid-template-columns: 76px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n}\n\n.ModernImageModelNode-field > span {\n  color: #596273;\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.ModernImageModelNode-field select {\n  width: 100%;\n  height: 34px;\n  padding: 0 30px 0 10px;\n  border: 1px solid #dde1e8;\n  border-radius: 9px;\n  outline: 0;\n  background: #fff;\n  color: #252d3a;\n  font-size: 12px;\n}\n\n.ModernImageModelNode-field select:focus {\n  border-color: var(--model-accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--model-accent) 11%, transparent);\n}\n\n.ModernImageModelNode-segments {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: 1fr;\n  overflow: hidden;\n  border: 1px solid #dde1e8;\n  border-radius: 9px;\n  background: #f4f5f7;\n}\n\n.ModernImageModelNode-segments button {\n  min-width: 0;\n  height: 32px;\n  border: 0;\n  border-right: 1px solid #e4e7ec;\n  background: transparent;\n  color: #687284;\n  font-size: 10px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.ModernImageModelNode-segments button:last-child {\n  border-right: 0;\n}\n\n.ModernImageModelNode-segments button.is-active {\n  background: var(--model-accent);\n  color: #fff;\n}\n\n.ModernImageModelNode-toggle {\n  display: grid;\n  grid-template-columns: 18px 1fr;\n  column-gap: 8px;\n  align-items: center;\n  margin: 0;\n  padding: 10px;\n  border: 1px solid #e3e6eb;\n  border-radius: 10px;\n  background: #f7f8f9;\n  cursor: pointer;\n}\n\n.ModernImageModelNode-toggle input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--model-accent);\n}\n\n.ModernImageModelNode-toggle span {\n  color: #323b49;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ModernImageModelNode-toggle small {\n  grid-column: 2;\n  margin-top: 2px;\n  color: #7a8494;\n  font-size: 10px;\n}\n\n.ModernImageModelNode-error {\n  padding: 8px 10px;\n  border: 1px solid #ffd0cd;\n  border-radius: 9px;\n  background: #fff3f2;\n  color: #b42318;\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.ModernImageModelNode-generate {\n  display: inline-flex;\n  min-height: 42px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border: 0;\n  border-radius: 11px;\n  background: var(--model-accent);\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--model-accent) 20%, transparent);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 760;\n  cursor: pointer;\n}\n\n.ModernImageModelNode-generate:hover:not(:disabled) {\n  filter: brightness(0.94);\n  transform: translateY(-1px);\n}\n\n.ModernImageModelNode-generate:disabled,\n.ModernImageModelNode-segments button:disabled,\n.ModernImageModelNode-field select:disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n\n.ModernImageModelNode-spinner {\n  width: 13px;\n  height: 13px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: ModernImageModelNode-spin 0.8s linear infinite;\n}\n\n.ModernImageModelNode-duplicate {\n  position: absolute;\n  z-index: 4;\n  top: -12px;\n  right: -12px;\n  display: grid;\n  width: 28px;\n  height: 28px;\n  place-items: center;\n  border: 1px solid #e0e4ea;\n  border-radius: 9px;\n  background: #fff;\n  box-shadow: 0 5px 14px rgba(31, 42, 68, 0.14);\n  color: #515c6c;\n  cursor: pointer;\n}\n\n.ModernImageModelNode-handle {\n  width: 11px !important;\n  height: 11px !important;\n  border: 2px solid #fff !important;\n  background: var(--model-accent) !important;\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--model-accent) 35%, #d5dae3);\n}\n\n.ModernImageModelNode-handle-label {\n  position: absolute;\n  top: 50%;\n  right: 13px;\n  width: max-content;\n  padding: 3px 7px;\n  transform: translateY(-50%);\n  border: 1px solid #e0e4ea;\n  border-radius: 7px;\n  background: #fff;\n  color: #596273;\n  font-size: 10px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n@keyframes ModernImageModelNode-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
